module.exports = __webpack_public_path__ + "static/betway-banner.ce9ef9f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/betway-banner.jpg
// module id = 471
// module chunks = 35783957827783